import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface CarHireSearchLabels {
  pickUpDropOffLocationTitle: string
  pickUpLocationTitle: string
  dropOffLocationTitle: string
  pickUpLocationPlaceholder: string
}

/**
 * Returns localized labels for car hire location search inputs.
 * This hook should be used instead of the constants in constants/carHire.ts
 * for user-facing label strings.
 */
function useCarHireSearchLabels(): CarHireSearchLabels {
  const intl = useIntl()

  return useMemo(() => ({
    pickUpDropOffLocationTitle: intl.formatMessage({
      id: 'p5t2hM/oAk',
      defaultMessage: 'Pick-up & Drop-off location',
      description: 'Title for car hire combined pick-up and drop-off location search',
    }),
    pickUpLocationTitle: intl.formatMessage({
      id: '0ka642OkwW',
      defaultMessage: 'Pick-up location',
      description: 'Title for car hire pick-up location search',
    }),
    dropOffLocationTitle: intl.formatMessage({
      id: 'CfNmIMdSWY',
      defaultMessage: 'Drop-off location',
      description: 'Title for car hire drop-off location search',
    }),
    pickUpLocationPlaceholder: intl.formatMessage({
      id: 'gT2JKj3nMj',
      defaultMessage: 'Search for an airport or city',
      description: 'Placeholder for car hire location search input',
    }),
  }), [intl])
}

export default useCarHireSearchLabels
